import React, { memo } from "react";

const AppSchedulerIcon = ({ color = "#ffffff", ...props }) => {
	return (
		<svg {...props} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9,11H7v2h2V11z M13,11h-2v2h2V11z M17,11h-2v2h2V11z M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20H5V9h14V20z"
				fill={color}
			/>
		</svg>
	);
};

export default memo(AppSchedulerIcon);
